import React from 'react';
import { Components } from './styled';
import ProjectModal from '../../ProjectModal';
import ProjectPicker from '../../ProjectPicker';
import ProjectSearchDropdown from '../../ProjectSearchDropdown';
import useSearchDropdown, { SearchDropdownItem } from '../../../hooks/useSearchDropdown';
import { SMALL_PROJECT_MODAL_WIDTH } from '../../../utils/styled/dimensions';

const PickerBody = ({
  items,
  placeholder,
  confirmLabel,
  description,
  onConfirm,
  onCancel,
}: {
  items: SearchDropdownItem[];
  placeholder: string;
  confirmLabel: string;
  description?: string;
  onConfirm: (value: string) => void;
  onCancel: () => void;
}) => {
  const dropdownProps = useSearchDropdown({ items, singleSelect: true, dropdownType: 'basic' });
  const selected = dropdownProps.selectedItems?.[0]?.value as string | undefined;

  return (
    <>
      <Components.ModalBodyContainer>
        <Components.FieldWrapper>
          {description && <Components.FieldBasic>{description}</Components.FieldBasic>}
          <ProjectPicker dropdownProps={dropdownProps} notSetText={placeholder} />
          <ProjectSearchDropdown {...dropdownProps} searchPlaceholder={'Search by title'} />
          {items.length === 0 && <Components.ContentEmpty>Nothing available to add</Components.ContentEmpty>}
        </Components.FieldWrapper>
      </Components.ModalBodyContainer>
      <Components.ModalButtonsContainer>
        <Components.ModalTertiaryButton onClick={onCancel}>Cancel</Components.ModalTertiaryButton>
        <Components.ModalPrimaryButton
          type={'button'}
          disabled={!selected}
          onClick={() => selected && onConfirm(selected)}>
          {confirmLabel}
        </Components.ModalPrimaryButton>
      </Components.ModalButtonsContainer>
    </>
  );
};

// A small stacked modal to pick one existing item (course / lesson) from a searchable list.
const ContentPickerModal = ({
  isModalOpen,
  onModalClose,
  title,
  items,
  placeholder,
  confirmLabel,
  description,
  onConfirm,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  title: string;
  items: SearchDropdownItem[];
  placeholder: string;
  confirmLabel: string;
  description?: string;
  onConfirm: (value: string) => void;
}) => (
  <ProjectModal
    bodyChildren={
      <PickerBody
        items={items}
        placeholder={placeholder}
        confirmLabel={confirmLabel}
        description={description}
        onConfirm={onConfirm}
        onCancel={onModalClose}
      />
    }
    isModalOpen={isModalOpen}
    onModalClose={onModalClose}
    modalTitle={title}
    modalWidth={SMALL_PROJECT_MODAL_WIDTH}
    disableCloseOnClickAway
  />
);

export default ContentPickerModal;
